<script lang="ts">
	import '$lib/styles/marketing.css';
	import '$lib/styles/wiki.css';
	import { WikiHeader } from '$lib/features/wiki';
	import { MarketingFooter } from '$lib/marketing/MarketingFooter';
	import { SeoGlobal } from '$lib/ui/atoms/Seo';

	let { children } = $props();
</script>

<!-- Organization + WebSite JSON-LD — jak w (marketing); wiki to strony publiczne. -->
<SeoGlobal />

<div class="marketing">
	<WikiHeader />
	{@render children()}
	<!-- Wiki jest prerenderowana bez sesji (root guard zwraca isAuthenticated=false). -->
	<MarketingFooter isAuthenticated={false} />
</div>

<style>
	/* Wiki pozwala na scroll (app shell blokuje overflow). */
	:global(html),
	:global(body) {
		overflow-y: auto !important;
	}
</style>
